import React from 'react'
import Button from './Button.js'
import { Fade } from '../Transitions'

const SaveButton = ({ submitting, dirty }) => {
	return (
		<Fade>
			<Button
				htmlType="submit"
				disabled={!dirty}
				loading={submitting}
				type={submitting || dirty ? 'default' : 'ghost'}
			>
				{submitting || dirty ? 'Save changes' : 'All saved'}
			</Button>
		</Fade>
	)
}

export default SaveButton



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Button/SaveButton.js